import PropTypes from "prop-types"

import "./styles.less"

// A round initials avatar: the person's first letter on a soft tinted circle. When there
// is no profile photo we still give everyone a stable, distinct look by deriving the tint
// from their name (same name -> same colour), so team members read apart at a glance.
const TONES = ["blue", "green", "orange", "purple", "red"]

const toneFor = (name = "") => {
  let h = 0
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) | 0
  return TONES[Math.abs(h) % TONES.length]
}

const initialOf = (name = "") => name.trim().charAt(0).toUpperCase() || "?"

const Avatar = ({ name, size = 24, className = "" }) => (
  <span
    className={`ui-avatar ui-avatar--${toneFor(name)} ${className}`.trim()}
    style={{ width: size, height: size, minWidth: size, fontSize: Math.round(size * 0.44) }}
    aria-hidden="true"
    title={name || undefined}
  >
    {initialOf(name)}
  </span>
)

Avatar.propTypes = {
  name: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default Avatar
